module.exports = __webpack_public_path__ + "static/media/parallax-clouds.987248f4.svg";